import React, { useState } from "react";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { splashscreen } from "api/splashscreen";
import { logSSO } from "api/account";
import Loader from "react-loader-spinner";
import { useDispatch } from "react-redux";
import { setTokens } from "store/actions/authActions";
import { setAccountDatas } from "store/actions/accountActions";
import * as microsoftTeams from "@microsoft/teams-js";
import "./TeamsSSO.scss";
import Axios from "axios";
import LogoCustomTheme from "components/Theme/Logo/LogoCustomTheme";

const LoaderComponent = () => {
  const { t } = useTranslation();

  return (
    <div className="loading">
      <p>{t("sso_loading")}</p>
      <Loader
        type="BallTriangle"
        color="#00BFFF"
        height={50}
        width={50}
        visible
      />
    </div>
  );
};

const TeamsSSO = () => {
  const [background, setbackground] = useState("");
  const [error, seterror] = useState(false);
  const [created, setcreated] = useState(false);
  const [loading, setloading] = useState(true);
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const onTeamsInitialization = () => {
    const aadRessource = process.env.REACT_APP_AAD;

    console.log("Trying to get authentication token from teams");
    microsoftTeams.authentication.getAuthToken({
      successCallback: onSuccess,
      failureCallback: onFailure,
      resources: [aadRessource],
    });
  };

  useEffect(() => {
    console.log("Trying to initialize teams SDK in React");
    microsoftTeams.initialize(onTeamsInitialization);

    splashscreen().then((data) => {
      setbackground(
        process.env.REACT_APP_BACKEND +
          "uploads/splashscreen/picture/" +
          data[0]?.picture
      );
    });
  }, []);

  const logTeamsError = React.useCallback((error) => logSSO(error), []);

  const onSuccess = (token) => {
    console.log("Received auth token from Teams: ", token);
    console.log("Trying to log in with tokens");

    setloading(true);
    Axios.post(
      process.env.REACT_APP_BACKEND + "api/sso/connect",
      {},
      {
        headers: {
          "SSO-Token": token,
        },
      }
    )
      .then((res) => {
        console.log("Successfully logged in");
        if (res.status === 201) {
          console.log("This is a new user registration");
          setcreated(true);

          // Redirect after 3 seconds since its user first connection
          setTimeout(() => {
            fetchProfile(res.data.data);
          }, 3000);
          return;
        }

        fetchProfile(res.data.data);
      })
      .catch((e) => {
        console.error("Could not log in sso",e);
        logTeamsError("Could not log in");
        seterror(true);
      })
      .finally(() => {
        setloading(false);
      });
  };

  const onFailure = (reason) => {
    console.log("Could not receive auth token from teams: ", reason);

    logTeamsError(reason);
    seterror(true);
    setloading(false);
  };

  const fetchProfile = (tokens) => {
    console.log("Trying to fetch user data");

    Axios.get(process.env.REACT_APP_BACKEND + "api/account", {
      headers: {
        Authorization: `Bearer ${tokens.access_token}`,
      },
    })
      .then(({ data }) => {
        console.log("User data fetched successfully");
        const expire_date = Date.now() + 30 * 1000 * 60 * 60 * 24;

        dispatch(
          setTokens({
            ...tokens,
            expire_date: expire_date,
          })
        );

        // stockage user dans redux
        dispatch(setAccountDatas(data));
      })
      .catch((emsg) => {
        console.error("Could not fetch user data",emsg);
        logTeamsError("Could not fetch user data");
        seterror(true);
      });
  };

  return (
    <div className="intro-bg" style={{ backgroundImage: `url(${background})` }}>
      <div className="teams-sso-container">
        <LogoCustomTheme className="we-are-ll" />
        <div className="teams-sso-content">
          {loading && <LoaderComponent />}
          {error && <p>{t("sso_error")}</p>}
          {created && !error && (
            <p>Your profile has been created successfully</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default TeamsSSO;
